/* NATTA sale countdowns + cart reservation timer (Tim 2026-10-15). Loaded by sections/natta-sale-bar.liquid, snippets/natta-selling-fast.liquid
   and snippets/natta-cart-timer.liquid; several may load it on one page, so everything below runs once.
   - The sale bar and "Selling out fast" count down to 00:00 in the visitor's own time zone ("salen ändar 00:00 lokal tid från där man är"),
     then start again for the next day. In that mode "Sale ends" is the last sale DAY in the visitor's own calendar: the bar goes away at
     their midnight after it, wherever they are.
   - The cart says the order is reserved for N minutes (10), counted from the moment the visitor opens the cart ("när man kommer in i kartan"). */
(() => {
  if (window.__nattaSale) return;
  window.__nattaSale = true;

  const pad = (n) => String(n).padStart(2, '0');
  const nextMidnight = () => { const d = new Date(); d.setHours(24, 0, 0, 0); return d.getTime(); };   // the coming 00:00, local time
  const localDay = () => { const d = new Date(); return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); };
  const split = (ms) => {
    let s = Math.max(0, Math.floor(ms / 1000));
    const d = Math.floor(s / 86400); s -= d * 86400;
    const h = Math.floor(s / 3600); s -= h * 3600;
    const m = Math.floor(s / 60); s -= m * 60;
    return { d, h, m, s };
  };

  // Sale bar: h / m / s boxes (days only when there are any). data-mode="midnight" (default) or "date" (to the exact data-end moment).
  customElements.define('natta-countdown', class extends HTMLElement {
    connectedCallback() {
      this.endRaw = this.dataset.end || '';
      this.end = Date.parse(this.endRaw);
      this.lastDay = /^\d{4}-\d{2}-\d{2}/.test(this.endRaw) ? this.endRaw.slice(0, 10) : '';
      this.u = {};
      this.querySelectorAll('[data-u]').forEach((b) => { this.u[b.dataset.u] = b; });
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    hide() {
      clearInterval(this.timer);
      const box = this.closest('.shopify-section') || this.closest('.natta-sale-bar');
      if (box) box.style.display = 'none';
    }
    tick() {
      const now = Date.now(), byDate = this.dataset.mode === 'date', hideAfter = this.dataset.hideAfter === 'true';
      let target;
      if (byDate) {
        if (!Number.isFinite(this.end)) { this.hidden = true; clearInterval(this.timer); return; }
        if (now >= this.end && hideAfter) { this.hide(); return; }
        target = this.end;
      } else {
        if (this.lastDay && hideAfter && localDay() > this.lastDay) { this.hide(); return; }   // past the last sale day, in the visitor's calendar
        target = nextMidnight();
      }
      const t = split(target - now);
      this.classList.toggle('no-days', t.d === 0);
      if (this.u.d) this.u.d.textContent = String(t.d);
      if (this.u.h) this.u.h.textContent = pad(t.h);
      if (this.u.m) this.u.m.textContent = pad(t.m);
      if (this.u.s) this.u.s.textContent = pad(t.s);
    }
  });

  // "Selling out fast": hh:mm:ss to the visitor's next 00:00 (hours keep counting past 24 on the 25-hour day in autumn).
  customElements.define('natta-midnight', class extends HTMLElement {
    connectedCallback() { this.tick(); this.timer = setInterval(() => this.tick(), 1000); }
    disconnectedCallback() { clearInterval(this.timer); }
    tick() { const t = split(nextMidnight() - Date.now()); this.textContent = pad(t.d * 24 + t.h) + ':' + pad(t.m) + ':' + pad(t.s); }
  });

  // Cart: "Your order is reserved for 10:00". The clock starts when the visitor opens the cart drawer (or lands on /cart); while the drawer
  // is closed it shows what is left of a running reservation, or the full time. One deadline for the whole site (localStorage, with an
  // in-memory copy when storage is blocked), so a re-rendered drawer or the next page keeps counting; when it runs out it starts again.
  const KEY = 'natta-cart-reserved-until';
  let mem = 0;
  const readDeadline = () => { let v = 0; try { v = Number(localStorage.getItem(KEY)) || 0; } catch (e) {} return v || mem; };
  const writeDeadline = (v) => { mem = v; try { localStorage.setItem(KEY, String(v)); } catch (e) {} };
  customElements.define('natta-cart-timer', class extends HTMLElement {
    connectedCallback() {
      this.ms = Math.max(1, Number(this.dataset.minutes) || 10) * 60000;
      this.out = this.querySelector('[data-t]');
      this.drawer = this.closest('cart-drawer');
      if (this.drawer) {
        this.mo = new MutationObserver(() => this.sync());
        this.mo.observe(this.drawer, { attributes: true, attributeFilter: ['class'] });
      }
      this.sync();
    }
    disconnectedCallback() { this.stop(); if (this.mo) this.mo.disconnect(); }
    open() { return !this.drawer || this.drawer.classList.contains('active'); }
    sync() { if (this.open()) this.start(); else { this.stop(); this.idle(); } }
    valid(v) { const left = v - Date.now(); return left > 0 && left <= this.ms + 5000; }   // a deadline from a longer setting is not kept
    idle() { const v = readDeadline(); this.show(this.valid(v) ? v - Date.now() : this.ms); }
    start() {
      if (this.timer) return;
      const v = readDeadline();
      this.until = this.valid(v) ? v : Date.now() + this.ms;
      writeDeadline(this.until);
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }
    stop() { clearInterval(this.timer); this.timer = null; }
    tick() {
      if (this.until - Date.now() <= 0) { this.until = Date.now() + this.ms; writeDeadline(this.until); }
      this.show(this.until - Date.now());
    }
    show(ms) { const s = Math.max(0, Math.ceil(ms / 1000)); if (this.out) this.out.textContent = pad(Math.floor(s / 60)) + ':' + pad(s % 60); }
  });

  // Dawn's drawer refresh after a cart change made elsewhere (onCartUpdate in cart.js) swaps only the items and the footer; the header
  // ("Cart (N items)"), the reserved box + free-shipping bar and the checkout button with the total are refreshed here.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (!event || event.source === 'cart-items' || !document.querySelector('#CartDrawer')) return;
      const url = ((window.routes && window.routes.cart_url) || '/cart') + '?section_id=cart-drawer';
      fetch(url).then((r) => r.text()).then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        for (const sel of ['#CartDrawer .drawer__header', '#CartDrawer .natta-cart-top', '#CartDrawer .cart__ctas']) {
          const a = document.querySelector(sel), b = html.querySelector(sel);
          if (a && b) a.replaceWith(b);
        }
      }).catch(() => {});
    });
  }
})();
